import { FontSizes, FontWeights, ITheme, mergeStyles } from '@fluentui/react';

export const getPrimaryMetricStyles = (theme: ITheme) =>
  mergeStyles({
    fontSize: FontSizes.size68,
    fontWeight: FontWeights.light,
    color: theme.palette.neutralPrimary,
    lineHeight: '68px',
    margin: 0,
  });

export const getPrimaryLabelStyles = (theme: ITheme) =>
  mergeStyles({
    fontSize: FontSizes.size14,
    fontWeight: FontWeights.regular,
    color: theme.palette.neutralSecondary,
    marginTop: '8px',
  });

export const getMetricRowStyles = (borderLeftColor: string) =>
  mergeStyles({
    borderLeft: `4px solid ${borderLeftColor}`,
    paddingLeft: '12px',
    marginBottom: '12px',
    flex: '1 1 0',
  });

export const getMetricValueStyles = (theme: ITheme) =>
  mergeStyles({
    fontSize: FontSizes.size20,
    fontWeight: FontWeights.semibold,
    color: theme.palette.neutralPrimary,
  });

export const getMetricLabelStyles = (theme: ITheme) =>
  mergeStyles({
    fontSize: FontSizes.size12,
    fontWeight: FontWeights.regular,
    color: theme.palette.neutralSecondary,
  });

export const detailsContainerStyles = mergeStyles({
  position: 'relative',
  height: '200px',
  marginTop: '10px',
});

export const getParentCompanyInfoStyles = (theme: ITheme) =>
  mergeStyles({
    marginBottom: '16px',
    fontSize: '14px',
    fontWeight: '400',
    color: theme.palette.neutralSecondary,
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
    paddingBottom: '8px',
  });

export const getCircleCheckIconStyles = (theme: ITheme) =>
  mergeStyles({
    fontSize: '20px',
    height: '20px',
    width: '20px',
    color: theme.palette.green,
  });
